import React from 'react';
import Button from '../../../common/buttons/onboarding/OnboardingButton';
import Loader from '../../../common/loader/Loader';
import { TIER_FEATURE_IDS } from '../../../../constants/Tiers';
import { TierFeatures } from '../../../../constants/TierFeatures';
import TierFeatureLoader from './TierFeatureLoader';

const TierLoader = ({ tiersLength }) => {
	return (
		<>
			{Array.apply(null, Array(tiersLength)).map((item, number) => {
				return (
					<article
						tabIndex={0}
						className="tierB tierB--loader"
						key={`tier-${number}`}
						aria-label={`tier-option-${number}`}
					>
						<div className="tierB__header">
							<Loader />
						</div>
						<div className="tierB-features">
							{Object.keys(TIER_FEATURE_IDS).map((tierFeatureId) => {
								const tierFeature = TierFeatures[tierFeatureId];
								return (
									<div className="tierB-feature" key={tierFeatureId}>
										<div className="tierB-feature__title">{tierFeature.title}</div>
										<TierFeatureLoader tierFeatureLength={1} />
									</div>
								);
							})}
						</div>
						<Button testId="tiersB-button" className="onboarding-button--tier-button">
							<Loader />
						</Button>
					</article>
				);
			})}
		</>
	);
};

export default TierLoader;
